import axios from "axios";
import format from "date-fns/format";
import formatDistance from "date-fns/formatDistance";
import idLocale from "date-fns/locale/id";
import MyUploadAdapter from "~/class/upload-adapter";
import toastDelete from "~/components/ToastDelete";
import { HIERARKI_CASE, NOTIF_KEY } from "./constant";
import { getAuthToken } from "~/helpers/authUtils";
import request from "./request";
import {
  HIERARKI_MODEL,
  HIERARKI_CASE_NAME,
  PASSWORD_SYMBOL,
  PALLETE_STYLES,
} from ".";

const listTableMapper = ({ query, response, typeList, version }) => {
  let result = [];

  const total_results =
    version === "v2"
      ? response?.data?.meta?.total
      : response?.data?.meta?.total_results;
  const { page, per_page } = response.data.meta;
  const { [typeList]: tableData } = response.data;

  const currentPage = page <= 1 ? per_page : per_page * page;

  const checkMaxPerpage = total_results < per_page ? total_results : per_page;

  for (let index = 0; index < checkMaxPerpage; index++) {
    if (page <= 1) {
      result[index] = tableData[index];
    } else {
      if (tableData[index]) {
        result[currentPage - per_page + index] = tableData[index];
      }
    }
  }

  if (query) {
    result = tableData;
  }

  return result;
};

const splitIndex = (value, index) => {
  return value.substring(0, index) + "," + value.substring(index);
};

const filterRoutes = (routes, hierarki, role) => {
  if (routes && hierarki !== undefined && role !== undefined) {
    if (hierarki !== null) {
      routes
        .filter((item) => item?.roles.indexOf(role) !== -1)
        .map((route) => {
          Object.entries(hierarki).forEach(([key, value]) => {
            if (key === route.type) {
              route.show = value;
            }

            if (
              key === "jenis_subdesa" &&
              route.type === "subdesa" &&
              route.isRead
            ) {
              route.name = uppercaseFirstLetter(value);
            }

            if (
              key === "jenis_subsubdesa" &&
              route.type === "subsubdesa" &&
              route.isRead
            ) {
              route.name = uppercaseFirstLetter(value);
            }
          });
        });

      /* check if routes children */
      if (routes[0]?.show) {
        return routes?.filter((el) => el.show);
      }
      return routes;
    }
  }
};

const algorithmHierarki = (hierarki) => {
  if (
    hierarki?.subdesa &&
    hierarki?.subsubdesa &&
    hierarki?.rw &&
    hierarki?.rt
  ) {
    return HIERARKI_CASE_NAME.ALL;
  }

  if (
    hierarki?.subdesa &&
    hierarki?.subsubdesa &&
    hierarki?.rw &&
    !hierarki?.rt
  ) {
    return HIERARKI_CASE_NAME.SUBDESA_SUBSUBDESA_RW;
  }

  if (
    hierarki?.subdesa &&
    hierarki?.subsubdesa &&
    !hierarki?.rw &&
    hierarki?.rt
  ) {
    return HIERARKI_CASE_NAME.SUBDESA_SUBSUBDESA_RT;
  }

  if (
    hierarki?.subdesa &&
    !hierarki?.subsubdesa &&
    hierarki?.rw &&
    hierarki?.rt
  ) {
    return HIERARKI_CASE_NAME.SUBDESA_RW_RT;
  }

  if (
    hierarki?.subdesa &&
    hierarki?.subsubdesa &&
    !hierarki?.rw &&
    !hierarki?.rt
  ) {
    return HIERARKI_CASE_NAME.SUBDESA_SUBSUBDESA;
  }

  if (
    hierarki?.subdesa &&
    !hierarki?.subsubdesa &&
    hierarki?.rw &&
    !hierarki?.rt
  ) {
    return HIERARKI_CASE_NAME.SUBDESA_RW;
  }

  if (
    hierarki?.subdesa &&
    !hierarki?.subsubdesa &&
    !hierarki?.rw &&
    hierarki?.rt
  ) {
    return HIERARKI_CASE_NAME?.SUBDESA_RT;
  }

  if (
    hierarki?.subdesa &&
    !hierarki?.subsubdesa &&
    !hierarki?.rw &&
    !hierarki?.rt
  ) {
    return HIERARKI_CASE_NAME.SUBDESA;
  }
};

const nullChecker = (cell) => (!cell ? "-" : cell);

const year = () => {
  let options = [];
  let startYear = 2000;
  let endYear = new Date().getFullYear();

  for (let i = endYear; i > startYear; i--) {
    // make a object to push to options array
    let obj = {};
    // react select recuitment
    obj["value"] = i;
    obj["label"] = i;
    options.push(obj);
  }

  return options;
};

const parseToGeoJson = (data) => {
  return {
    type: "FeatureCollection",
    features: data.map((feature, index) => {
      const { geometry, ...properties } = feature;
      return {
        type: "Feature",
        geometry: geometry,
        properties: { ...properties, index, active: false },
      };
    }),
  };
};

function parseVideo(url) {
  url.match(
    /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
  );

  if (RegExp.$3.indexOf("youtu") > -1) {
    var type = "youtube";
  } else if (RegExp.$3.indexOf("vimeo") > -1) {
    var type = "vimeo";
  }

  return {
    type: type,
    id: RegExp.$6,
  };
}

const validURL = (str) => {
  var pattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // fragment locator
  return !!pattern.test(str);
};

const isFile = (input) => {
  if ("File" in window && input instanceof File) return true;
  else return false;
};

const listPetaMapper = (data, key, type, zoom) =>
  data.map((item) => ({ ...item, name: item[key], type, zoom }));

const parsePetaBidangGeoJson = (data, name, item) =>
  data.map((feature, index) => {
    const { geometry, ...properties } = feature;
    return {
      ...item,
      geoJson: {
        type: "Feature",
        geometry: geometry,
        properties: {
          ...properties,
          name: properties[name],
          index,
        },
      },
    };
  });

const getAsyncSelect = async (value, url) => {
  try {
    const { data: req } = await request.get(`/v1/${url}/?search=${value}`);

    return req;
  } catch {}
};

export const getPendudukFilter = async (value, filter, isfilter) => {
  try {
    const { data: req } = await request.get(`/v1/penduduk/?search=${value}`);

    return req.data.map((option) => ({
      label: option.nik,
      value: option.id,
      nama: option.nama,
    }));
  } catch {}
};

const flattenRoutes = (routes) => {
  let flatRoutes = [];

  routes = routes || [];
  routes.forEach((item) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

function isJSON(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

function uuidv4() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    let r = (Math.random() * 16) | 0,
      v = c == "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

const toRupiah = (angka) => {
  const rupiah = new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(angka);
  return `${rupiah} ,-`;
};

const sumObject = (list, key) => {
  return list?.reduce((a, b) => a + (b[key] || 0), 0);
};

const base64Validation = (base64) =>
  base64.replace(/^data:image.+;base64,/, "");

const capitalizeFirstLetter = (string) => {
  const capitalize = string?.charAt(0).toUpperCase() + string?.slice(1);
  const replaceUselessString = capitalize
    ?.replaceAll("_", " ")
    ?.replaceAll("jk", "Jenis Kelamin")
    ?.replaceAll("status_dalam_keluarga", "Status dalam keluarga")
    ?.replaceAll("Chip ektp", "Chip EKTP")
    ?.replaceAll("Totalabsensi", "Total Absensi");

  return replaceUselessString;
};

const findLegendaBySameValues = (legenda, setInitialLegenda, ubah) => {
  if (ubah) {
    legenda.map((el) => {
      // find value
      const datasWarna = {
        ket_color: el.ket_color,
        warna: el.warna,
      };

      const datasIcon = {
        ket_icon: el.ket_icon,
        icon: el.icon,
      };

      if (el.icon && el.ket_icon) {
        return setInitialLegenda((prevInitialData) => [
          ...prevInitialData,
          datasIcon,
        ]);
      }

      return setInitialLegenda((prevInitialData) => [
        ...prevInitialData,
        datasWarna,
      ]);
    });
  } else {
    legenda.map((el) => {
      // find value
      const value = el.tipe.daftar_legenda?.find(
        (el2) =>
          el2?.ket_color === el?.properties?.nama ||
          el2?.ket_icon?.toUpperCase() === el?.properties?.nama
      );

      if (value !== undefined) {
        const isValue = value?.warna || value?.icon;
        const datas = { ket: el.properties.nama, value: isValue };
        return setInitialLegenda((prevInitialData) => [
          ...prevInitialData,
          datas,
        ]);
      } else {
        const datas = { ket: el.properties.nama, value: "" };

        return setInitialLegenda((prevInitialData) => [
          ...prevInitialData,
          datas,
        ]);
      }
    });
  }
};

const timer = (ms) => new Promise((res) => setTimeout(res, ms));

async function loopLegenda(
  values,
  desa,
  initialData,
  setLoadingPut,
  put,
  legendaNow,
  slug,
  toast,
  history,
  actionLegenda
) {
  const conditionalPut = (put && actionLegenda === "edit") || put;
  const legendaLength = values?.legenda?.length;
  for (let [i, el] of values?.legenda.entries()) {
    const datas = {
      ...el,
      desa: desa?.id,
      sigtipe: initialData?.[0]?.id,
    };

    setLoadingPut(true);

    if (conditionalPut) {
      request
        .put(`/v1/legenda/${legendaNow[i].id}/`, datas)
        .then(() => {
          // checked last index
          if (legendaLength === i + 1) {
            toast.success(
              `Legenda ${capitalizeFirstLetter(slug)} berhasil diubah !`
            );
            history.push("/user/peta/tipe-peta");
          }
        })
        .finally(() => {
          // checked last index
          if (legendaLength === i + 1) {
            setLoadingPut(false);
          }
        });
    } else {
      request
        .post("/v1/legenda/", datas)
        .then(() => {
          // checked last index
          if (legendaLength === i + 1) {
            toast.success(
              `Legenda ${capitalizeFirstLetter(slug)} berhasil ditambahkan !`
            );
            history.push("/user/peta/tipe-peta");
          }
        })
        .finally(() => {
          // checked last index
          if (legendaLength === i + 1) {
            setLoadingPut(false);
          }
        });
    }

    await timer(1500);
  }
}

const uniqueArray = (array) => {
  const results = array?.filter((thing, index) => {
    const _thing = JSON.stringify(thing);
    return (
      index ===
      array.findIndex((obj) => {
        return JSON.stringify(obj) === _thing;
      })
    );
  });

  return results;
};

const urlToBase64 = async (imageUrl) => {
  let res = await fetch(imageUrl);
  let blob = await res.blob();
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.addEventListener(
      "load",
      function () {
        resolve(reader.result);
      },
      false
    );
    reader.onerror = () => {
      return reject(this);
    };
    reader.readAsDataURL(blob);
  });
};

const base64Formatter = (str) => `data:image/png;base64,${str}`;

const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () =>
      resolve(reader.result.replace(/^data:image.+;base64,/, ""));
    reader.onerror = (error) => reject(error);
  });

const handleDeleteUndo = (
  url,
  toggleDelete,
  setDeleteItem,
  setUndoItem,
  deleteItem,
  undoItem
) => {
  toggleDelete();
  setDeleteItem(deleteItem?.id);
  toastDelete(url, () => {
    setUndoItem(deleteItem);
    // change to defaultData
    // setTimeout(() => {
    //   setDeleteItem(false);
    //   setUndoItem(false);
    // }, 300);
  });

  setTimeout(() => {
    if (undoItem === false) {
      console.log("data has been deleted");
    }
  }, 10000);
};

const convertDate = (date) => {
  let pattern = /(\d{4})\-(\d{2})\-(\d{2})/;
  if (!date || !date.match(pattern)) {
    return "-";
  }

  const defaultDate = date.replace(pattern, "$2/$3/$1");

  const formatDate = format(new Date(defaultDate), `cccc, d LLLL yyyy`, {
    locale: idLocale,
    addSuffix: true,
  });

  return formatDate;
};

const convertFormatDistance = (date) => {
  let pattern = /(\d{4})\-(\d{2})\-(\d{2})/;
  if (!date || !date.match(pattern)) {
    return "-";
  }

  const defaultDate = date.replace(pattern, "$2/$3/$1");

  const formatDate = formatDistance(new Date(), new Date(defaultDate), {
    locale: idLocale,
    addSuffix: true,
    includeSeconds: true,
  });

  return formatDate;
};

const validateURLAPI = (url) => {
  return `${process.env.REACT_APP_API_URL}${url}`;
};

const convertDatePresensi = (date) => {
  let pattern = /(\d{4})\-(\d{2})\-(\d{2})/;
  if (!date || !date.match(pattern)) {
    return "-";
  }

  const defaultDate = date.replace(pattern, "$2/$3/$1");

  const formatDate = format(new Date(defaultDate), `cccc, d LLLL yyyy, HH:mm`, {
    locale: idLocale,
    addSuffix: true,
  });

  return formatDate;
};

const getCaseByHierarki = (rt, rw, subsubdesa, subdesa) => {
  let caseData;

  if (rt && rw && subsubdesa && subdesa) {
    caseData = HIERARKI_CASE.ONE;
  }

  if (rt && rw && !subsubdesa && subdesa) {
    caseData = HIERARKI_CASE.TWO;
  }

  if (!rt && !rw && subsubdesa && subdesa) {
    caseData = HIERARKI_CASE.THREE;
  }

  if (!rt && !rw && !subsubdesa && subdesa) {
    caseData = HIERARKI_CASE.FOUR;
  }

  return caseData;
};

const customUploadAdapterPlugin = (editor) => {
  editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
    return new MyUploadAdapter(loader);
  };
};

const httpsValidation = (url) => {
  if (url?.search(/http:/g) === 0) {
    return url?.replace("http", "https");
  }

  return url;
};

const getAbsolutePath = () => {
  const absolutePath = window.location.href.replace(/^.*\/\/[^\/]+/, "");

  return absolutePath;
};

const checkingGetAwayImage = (watchGambar) => {
  const results = typeof watchGambar !== "string" && watchGambar;

  return results;
};

const isLatitude = (lat) => {
  return isFinite(lat) && Math.abs(lat) <= 90;
};

const isLongitude = (lng) => {
  return isFinite(lng) && Math.abs(lng) <= 180;
};

const replaceToFullPath = (relativePath) =>
  `${process.env.REACT_APP_API_URL}${relativePath}`;

const renderToFeaturesAttribution = (datas) => {
  const isDatas = datas?.data ?? datas;

  const features = isDatas?.map((feature) => {
    const { geometry, ...properties } = feature;
    return {
      type: "Feature",
      geometry: geometry,
      properties: properties,
    };
  });

  return features;
};

const notificationAlert = (title, options) => {
  // Let's check if the browser supports notifications
  if (!("Notification" in window)) {
    alert("This browser does not support desktop notification");
  }

  // Let's check whether notification permissions have already been granted
  else if (Notification.permission === "granted") {
    // If it's okay let's create a notification
    new Notification(title, options);
  }

  // Otherwise, we need to ask the user for permission
  else if (Notification.permission !== "denied") {
    Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        new Notification(title, options);
      }
    });
  }
};

const getSocketNotificationURL = () => {
  const authToken = getAuthToken();

  const socketURL = `wss://${process.env.REACT_APP_API_URL.replace(
    "https://",
    ""
  )}/ws/notifications?token=${authToken.access}`;

  return socketURL;
};

const ucFirst = (t) => {
  if (t) {
    const lowerCaseT = t?.toLowerCase();
    const replaceUniqueCharacter = replaceAll(lowerCaseT, "_", " ");

    return replaceUniqueCharacter.replace(/(^|\s)[A-Za-zÀ-ÖØ-öø-ÿ]/g, (c) =>
      c.toUpperCase()
    );
  }
};

const getNotifInformation = (isNotif) => {
  let icon;
  let style;
  let href;

  switch (isNotif.key) {
    case NOTIF_KEY.LAPOR:
      icon = `mdi mdi-alert-octagon`;
      style = `info`;
      href = `/user/lapor/lapor-warga?page=1&per_page=5&q=&active=${isNotif.obj_id}`;
      break;
    case NOTIF_KEY.LAYANAN:
      icon = `mdi mdi-face-agent`;
      style = `warning`;
      href = `/user/layanan/daftar-layanan-administrasi/${isNotif.jenis_surat}?page=1&per_page=5&q=&active=${isNotif.obj_id}`;
      break;
    case NOTIF_KEY.POTENSI:
      icon = `mdi mdi-star`;
      style = `success`;
      href = `/user/website/potensi/daftar-potensi?page=1&per_page=5&active=${isNotif.obj_id}`;
      break;
    default:
      icon = "";
      style = "";
      href = "";
  }

  return {
    icon,
    style,
    href,
  };
};

const checkHollowMaps = (
  hollowMaps,
  styles,
  type,
  isActiveLayer,
  sigTipeNama
) => {
  if (hollowMaps) {
    if (isActiveLayer) {
      return {
        color: "#000",
        fillColor: "transparent",
        fillOpacity: 0,
        weight: 5,
      };
    }

    return {
      weight: 1,
      fillOpacity: 0,
      fillColor: "transparent",
      color: sigTipeNama?.toLowerCase()?.includes("jalan") ? "blue" : "red",
    };
  } else {
    if (isActiveLayer) {
      return {
        color: "#000",
        fillOpacity: 1,
        weight: 5,
        fillColor: styles.fillColor,
      };
    }

    // if (isCreating) {
    //   if (type === "MultiLineString" || type === "LineString") {
    //     return {
    //       weight: 1.7,
    //       color: styles.fillColor,
    //     };
    //   } else {
    //     return {
    //       ...styles,
    //       color: styles.fillColor,
    //       fillColor: styles.fillColor,
    //       weight: 1,
    //       fillOpacity: 2,
    //     };
    //   }
    // }

    if (type === "MultiLineString" || type === "LineString") {
      return {
        weight: 1.7,
        color: styles.fillColor,
      };
    } else {
      return styles;
    }
  }
};

const getDynamicStyleLayer = () => {};

const requestDownloadMedia = (url) => {
  axios
    .get(`${process.env.REACT_APP_API_URL}${url}`, {
      responseType: "blob",
    })
    .then((res) => res);
};

const replaceAll = (text, replaceFrom, replaceAfter) => {
  const regex = new RegExp(replaceFrom, "g");
  const results = text?.replace(regex, replaceAfter);

  return results;
};

const uppercaseFirstLetter = (words) => {
  if (words) {
    let wordList = words?.split(" ");

    for (let i = 0; i < wordList.length; i++) {
      if (wordList[i].length < 3) {
        wordList[i] = wordList[i].toUpperCase();
      } else {
        wordList[i] = wordList[i][0].toUpperCase() + wordList[i].substr(1);
      }
    }

    return wordList.join(" ")?.replace(/_/g, " ")?.replace(/-/g, " ");
  }
};

const isLetter = (str) => /\p{L}/u.test(str);

const changeHierarkiExistingToHierarkiModel = (currentHierarki, hierarki) => {
  switch (currentHierarki?.toLowerCase()) {
    case HIERARKI_MODEL.DESA:
      return HIERARKI_MODEL.DESA;
    case hierarki?.jenis_subdesa:
      return HIERARKI_MODEL.SUBDESA;
    case hierarki?.jenis_subsubdesa:
      return HIERARKI_MODEL.SUBSUBDESA;
    case HIERARKI_MODEL.RW:
      return HIERARKI_MODEL.RW;
    case HIERARKI_MODEL.RT:
      return HIERARKI_MODEL.RT;
    case HIERARKI_MODEL.BIDANG:
      return HIERARKI_MODEL.BIDANG;
    default:
      return HIERARKI_MODEL.DESA;
  }
};

let h2rs = {};

const h2r = (hex) => {
  hex = "#" == hex[0] ? hex.slice(1) : hex;
  if (h2rs[hex]) return h2rs[hex];
  let int = parseInt(hex, 16);
  let r = (int >> 16) & 255;
  let g = (int >> 8) & 255;
  let b = int & 255;
  return (h2rs[hex] = { r: r, g: g, b: b });
};

const hexToColorName = (hex, color_map) => {
  var rgb = h2r(hex);
  var min = Infinity;
  var closest = null;

  for (var color in color_map) {
    var rgb2 = h2r(color_map[color]);

    // distance formula
    var dist =
      Math.pow((rgb.r - rgb2.r) * 0.299, 2) +
      Math.pow((rgb.g - rgb2.g) * 0.587, 2) +
      Math.pow((rgb.b - rgb2.b) * 0.114, 2);

    if (dist <= min) {
      closest = color;
      min = dist;
    }
  }

  return closest;
};

const handleReaderGEOJSON = (files, setGeoJSONData) => {
  const geojsonData = files[0];

  const fileReader = new FileReader();

  fileReader.readAsText(geojsonData, "UTF-8");

  fileReader.onload = (event) => {
    const jsonData = JSON.parse(event.target.result);

    setGeoJSONData(jsonData);
  };
};

const validationNewPassword = (newPassword) => {
  /**
   * check if password has three requirement
   *
   * 1. has lowercase text
   * 2. has uppercase text
   * 3. has symbol text
   * 4. has number
   */

  if (newPassword) {
    const hasLowerCaseText = (str) => str.toUpperCase() != str;
    const hasUpperCaseText = (str) => str.toLowerCase() != str;
    const hasSymbolText = (str) =>
      PASSWORD_SYMBOL.some((password) => str.includes(password));

    const hasNumber = /\d/.test(newPassword);
    const isSymbol = hasSymbolText(newPassword);
    const isLowerCase = hasLowerCaseText(newPassword);
    const isUpperCase = hasUpperCaseText(newPassword);

    if (isLowerCase && isUpperCase && isSymbol && hasNumber) {
      return true;
    }

    return false;
  }
};

const integrationLegendaChecking = (feature, code) => {
  const result = `${feature?.properties?.jumlah_kepemilikan > 0} ${code}
    ${feature?.properties?.jumlah_kepenguasaan > 0} ${code}
    ${feature?.properties?.pemanfaatan_tanah} ${code}
    ${feature?.properties?.penggunaan_tanah}`;

  return result;
};

const isEven = (n) => {
  return n % 2 == 0;
};

const isMultiValueToString = (arr, keyMapper, separator) => {
  if (arr?.length > 0) {
    const mapperResult = arr.map((a) => a[keyMapper]);

    return mapperResult.join(separator);
  }

  return "-";
};

const renderClasificationAttribute = (geoJSON, clasificationAttributName) => {
  const geoJSONMapper = geoJSON.features.map(
    (feature) => feature.properties[clasificationAttributName]
  );

  return uniqueArray(geoJSONMapper).map((feature, i) => {
    return {
      nama: feature,
      fillColor: PALLETE_STYLES[i % PALLETE_STYLES.length],
    };
  });
};

const getNumberList = (index, page = 1, perPage = 5) => {
  return index + 1 + (parseInt(page ?? 1) - 1) * parseInt(perPage ?? 5);
};

const filterValuesObject = (values, keyArray) => {
  const filterValues = Object.entries(values).filter(
    ([key]) => !keyArray.includes(key)
  );

  return Object.fromEntries(filterValues);
};

const getLabelFromName = (name) => {
  const lowerCaseName = replaceAll(
    replaceAll(name?.toLowerCase(), "_", ""),
    "-",
    ""
  );

  return { lowerCaseName, label: ucFirst(lowerCaseName) };
};

const rupiahToInt = (rupiah) => {
  const int = replaceAll(replaceAll(String(rupiah), "Rp", ""), ",", "");

  return parseInt(int);
};

function backendErrorFieldMessage(fieldValues, error, setError, clearErrors) {
  const errors = error?.response?.data?.errors;

  if (errors && typeof errors === "object") {
    errors.forEach((errorGroup) => {
      Object.entries(errorGroup).forEach(([fieldName, messages]) => {
        const message =
          Array.isArray(messages) && messages.length > 0 ? messages[0] : null;

        if (fieldValues.hasOwnProperty(fieldName) && message) {
          setError(fieldName, { message, type: "backend" });
        }
      });
    });
  }

  if (errors && Array.isArray(errors)) {
    errors.forEach((item) => {
      Object.entries(item).forEach(([fieldName, messages]) => {
        const message =
          Array.isArray(messages) && messages.length > 0 ? messages[0] : null;

        if (fieldValues.hasOwnProperty(fieldName) && message) {
          setError(fieldName, { message, type: "backend" });
        }
      });
    });
  }

  const clearErrorFunctions = [];
  const clearErrorMessage = () => {
    if (errors && typeof errors === "object") {
      errors.forEach((errorGroup) => {
        Object.keys(errorGroup).forEach((fieldName) => {
          if (clearErrors && typeof clearErrors === "function") {
            clearErrorFunctions.push(() => clearErrors(fieldName));
          }
        });
      });
    }
  };

  clearErrorMessage();

  return clearErrorFunctions;
}

export {
  listTableMapper,
  splitIndex,
  nullChecker,
  year,
  parseToGeoJson,
  listPetaMapper,
  parsePetaBidangGeoJson,
  getAsyncSelect,
  flattenRoutes,
  validURL,
  isFile,
  toRupiah,
  parseVideo,
  isJSON,
  uuidv4,
  sumObject,
  filterRoutes,
  base64Validation,
  capitalizeFirstLetter,
  findLegendaBySameValues,
  loopLegenda,
  uniqueArray,
  urlToBase64,
  base64Formatter,
  toBase64,
  handleDeleteUndo,
  convertDate,
  validateURLAPI,
  convertDatePresensi,
  getCaseByHierarki,
  customUploadAdapterPlugin,
  httpsValidation,
  getAbsolutePath,
  checkingGetAwayImage,
  isLatitude,
  isLongitude,
  replaceToFullPath,
  renderToFeaturesAttribution,
  notificationAlert,
  convertFormatDistance,
  getSocketNotificationURL,
  ucFirst,
  getNotifInformation,
  getDynamicStyleLayer,
  requestDownloadMedia,
  replaceAll,
  uppercaseFirstLetter,
  isLetter,
  changeHierarkiExistingToHierarkiModel,
  checkHollowMaps,
  algorithmHierarki,
  hexToColorName,
  timer,
  handleReaderGEOJSON,
  validationNewPassword,
  integrationLegendaChecking,
  isEven,
  isMultiValueToString,
  renderClasificationAttribute,
  getNumberList,
  filterValuesObject,
  getLabelFromName,
  rupiahToInt,
  backendErrorFieldMessage,
};
